import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

/**
 * Usuarios de una academia (cualquier rol), vistos desde `superadmin/`.
 * Parche operativo (ver `useActivateCompanyUser`) mientras se resuelve el
 * incidente del proveedor de correo transaccional: sin esto, soporte no tiene
 * forma de ver ni desatascar una cuenta cuyo correo de activación nunca llegó.
 */
function useCompanyUsers(companyId) {
  return useQuery({
    queryKey: ["superadmin", "companies", companyId, "users"],
    queryFn: () =>
      apiClient
        .get(`/api/v1/superadmin/companies/${companyId}/users/`)
        .then((r) => r.data),
    enabled: Boolean(companyId),
  });
}

/** Activa manualmente `User.is_active` (no toca la membresía). */
function useActivateCompanyUser(companyId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (userId) =>
      apiClient
        .post(`/api/v1/superadmin/companies/${companyId}/users/${userId}/activate/`)
        .then((r) => r.data),
    onSuccess: () =>
      qc.invalidateQueries({
        queryKey: ["superadmin", "companies", companyId, "users"],
      }),
  });
}

export { useCompanyUsers, useActivateCompanyUser };
